import { render, staticRenderFns } from "./PosterTable.vue?vue&type=template&id=294851dc&scoped=true&"
import script from "./PosterTable.vue?vue&type=script&lang=ts&"
export * from "./PosterTable.vue?vue&type=script&lang=ts&"
import style0 from "./PosterTable.vue?vue&type=style&index=0&id=294851dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294851dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VIcon,VTooltip})
